import { ChangeDetectorRef, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class HasDetailsGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    const hasDetails = localStorage.getItem('hasDetails') === 'true';

    if (hasDetails) {
      return true;
    } else {
      this.router.navigate(['/profile']);
      return false;
    }
  }
}
